export default {
  selectView: { id: 'select_view' },
}
